"use client";

import { useRef, useState } from "react";

import { CloseIcon } from "@/components/icons/close.icon";

import type { GetNavigationQueryResult } from "@/sanity.types";

import { SiteHeaderMobileMenuContent } from "./siteHeaderMobileMenuContent.component";
import { SiteHeaderMobileMenuTitle } from "./siteHeaderMobileMenuTitle.component";

export const SiteHeaderMobileMenu = ({
  shopByMenu,
  mainMenu,
}: SiteHeaderMobileMenuProps) => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [selectedMenu, setSelectedMenu] = useState("");

  const closeModal = () => {
    dialogRef.current?.close();
  };

  return (
    <dialog
      ref={dialogRef}
      id="header-mobile-modal"
      data-testid="site-header-mobile-modal"
      aria-label="Mobile menu"
      aria-modal="true"
      className="m-0 box-border h-dvh max-h-dvh w-full max-w-none justify-start overflow-hidden border-0 bg-transparent p-0 backdrop:bg-black/30 open:fixed open:inset-0 open:z-50 open:flex lg:hidden"
      onClose={() => {
        document.body.style.overflow = "";
        setSelectedMenu("");
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          closeModal();
          return;
        }
        if ((event.target as HTMLElement).closest("a")) {
          closeModal();
        }
      }}>
      <div className="flex h-full w-full flex-col bg-white transition duration-500 starting:-translate-x-full">
        <header className="flex shrink-0 items-center justify-between gap-4 border-b border-black/10 px-6 py-4">
          <div className="min-w-0">
            <SiteHeaderMobileMenuTitle
              selectedMenu={selectedMenu}
              setSelectedMenu={setSelectedMenu}
              shopByMenu={shopByMenu}
            />
          </div>
          <button
            type="button"
            className="flex size-10 shrink-0 items-center justify-center"
            data-testid="site-header-mobile-menu-close"
            aria-label="Close mobile menu"
            onClick={closeModal}>
            <CloseIcon width={24} height={24} />
          </button>
        </header>
        <div className="min-h-0 flex-1 overflow-auto">
          <SiteHeaderMobileMenuContent
            menu={mainMenu}
            selectedMenu={selectedMenu}
            setSelectedMenu={setSelectedMenu}
          />
        </div>
      </div>
    </dialog>
  );
};

export type SiteHeaderMobileMenuProps = {
  shopByMenu?: GetNavigationQueryResult;
  mainMenu?: GetNavigationQueryResult;
};
